module.exports = __webpack_public_path__ + "static/media/logoutWhite.f5380e73.svg";